import CssBaseline from '@material-ui/core/CssBaseline'
import React from 'react'

const Baseline = () => {
  return(
    <CssBaseline />
  );
}

export default CssBaseline;
